import { render, staticRenderFns } from "./InformativaArruolamento.vue?vue&type=template&id=20255708&"
import script from "./InformativaArruolamento.vue?vue&type=script&lang=js&"
export * from "./InformativaArruolamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports